import { signal } from '@angular/core';

export const isSupportWebP = signal<boolean>(null);
